// @flow
import styled from 'styled-components';
import { TRANSITION_DEF } from '../../constants';

export const Container = styled.g`
    cursor: ${p => (p.isDisable ? 'default' : 'pointer')};

    &:hover > rect {
        fill: ${p => (p.isDisable ? p.theme.white : p.theme.mainBrandColor)};
    }
    &:hover > text {
        fill: ${p => (p.isDisable ? p.theme.mediumGrey : p.theme.white)};
    }
`;

export const Border = styled.rect`
    fill: ${p => p.theme.white};
    opacity: ${p => (p.isDisable ? 0.5 : 1)};
    stroke: ${p => (p.isDisable ? p.theme.mediumGrey : p.theme.mainBrandColor)};
    stroke-width: 1;
    transition: ${TRANSITION_DEF};
`;

export const Label = styled.text`
    fill: ${p => (p.isDisable ? p.theme.mediumGrey : p.theme.mainBrandColor)};
    opacity: ${p => (p.isDisable ? 0.5 : 1)};
    text-anchor: middle;
    transition: ${TRANSITION_DEF};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/control-panel/button/style.js